var angular = require('angular');

angular.module('pitch.app')
.controller('SynchCtrl', function($scope, SiteContext, Site, $sce, LicencingFormModal, $stateParams, articles, videos, $filter, Content) {
    "use strict";

    // ------ set article

    $scope.articles = articles;

    $scope.getHtml = function(html) {
        return $sce.trustAsHtml(html);
    };

    // ----- set videos

    $scope.videos = videos;

    // ----- get the synch contact data

    SiteContext.get().then(function(r) {
        Content.query({
            sortField: 'slot',
            sortOrder: 'ASC',
            featured: true,
            section: 'synch/aside:sites/' + r.id,
            pageSize: 8,
            details: true
        }, function(resp) {
            $scope.asides = resp;
        });
    });

    $scope.showform = function() {
        LicencingFormModal.open();
    };

    $scope.playVideo = function(video) {
        var index;

        //swap videos
        index = $scope.videos.indexOf(video);
        $scope.videos.splice(index, 1, $scope.selectedVideo);
        $scope.videos.splice(0, 1, video);

        //select video
        $scope.selectedVideo = video;
        $scope.selectedVideoUrl = $sce.trustAsResourceUrl($filter('asset')(video.assets, 'video').src);
    };


    // --- init

    if ($scope.videos.length) {
        $scope.playVideo($scope.videos[0]);
    }

    if ($stateParams.play) {
        angular.forEach($scope.videos, function (video) {
            if (video.id === $stateParams.play) {
                $scope.playVideo(video);
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/SynchCtrl.js